<ul *ngIf="includeModels">    
    <li *ngFor="let segment of segments" [ngClass]="segment.className">{{segment.name}}</li>    
</ul>

<ul *ngIf="!includeModels" class="centered">
    <li *ngFor="let row of rows">
        <ul><li class="key">{{row.key}}</li><li class="value">{{row.value}}</li></ul>
    </li>
</ul>

<div class="progress-container">
    <div class="progress-bar">
        <div class="progress-completed" [style.width.%]="progressPercent"></div>
        <div class="progress-indicator" [style.left.%]="progressPercent">
            <span title="Estimated progress {{ progressPercent }} %" class="progress-circle">{{ progressPercent }} %</span>
        </div>
    </div>
</div>

<div class="time-indicators">
    <!--<span class="elapsed-time" title="Approximate time spent so far {{ elapsedTime }} min">
        {{ elapsedTime }} min
    </span>
    <span class="remaining-time" title="Estimated time left {{ estimatedTimeLeft }} min">
        {{ estimatedTimeLeft }} min
    </span>-->
</div>